// import VueCoreVideoPlayer from "vue-core-video-player";
import waterfall from "vue-waterfall2";

import Vue from "vue";

// Vue.use(VueCoreVideoPlayer);
Vue.use(waterfall);
